import checkout from "./form13";

const {
  formField13: { totalTaxTNDN, totalExpense },
} = checkout;

const initialValues13 = {
  [totalTaxTNDN.name]: "",
  [totalExpense.name]: "",
};

export default initialValues13;
